module.exports = __webpack_public_path__ + "img/Loop.6ae59c8f.png";